/* unplugin-vue-components disabled */import { render } from "./popupOrder.vue?vue&type=template&id=2089fc63&scoped=true"
import script from "./popupOrder.vue?vue&type=script&lang=js"
export * from "./popupOrder.vue?vue&type=script&lang=js"

import "./popupOrder.vue?vue&type=style&index=0&id=2089fc63&lang=less&scoped=true"
import "./popupOrder.vue?vue&type=style&index=1&id=2089fc63&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2089fc63"]])

export default __exports__